import React, { useEffect, useState } from 'react';
import { SimpleView, GridView, Widget, MasterDetailForm } from '@digital/ui';
import { getAllParametros, Parametro, updateParametro, Historico, getAllHistoricos } from '@app/api/parametro';
import { CrfTipoClassificacaoProjeto, getAllCrfTipoClassificacaoProjeto, updateCrfTipoClassificacaoProjeto } from '@app/api/crf/crfTipoClassificacaoProjeto';
import { Collapse, Icon } from 'antd';

import TabelaHistorico from './TableHistorico';
import TabelaParametro from './TableParametros';
import { ECodigoParametro } from '@app/enums/ECodigoParametro';
import TabelaTipoClassificacaoProjeto from './TabelaTipoClassificacaoProjeto';

const { Panel } = Collapse;

interface IPropsConfiguracao {
  codigo: number;
}

const ConfiguracaoComponent = ({
  codigo = ECodigoParametro.Investimento,
}: IPropsConfiguracao) => {
  const [parametros, setParametros] = useState<Parametro[]>();
  const [historicos, setHistoricos] = useState<Historico[]>();
  const [tiposClassificacaoProjetos, setTiposClassificacaoProjetos] = useState<CrfTipoClassificacaoProjeto[]>();

  const getParametrosData = async () => {
    const result = await getAllParametros({ codigo });
    if (result && Array.isArray(result)) {
      setParametros(result);
    }
  };

  const getHistoricoData = async () => {
    const result = await getAllHistoricos({ codigo });
    if (result && Array.isArray(result)) {
      const resultadoHistorico = result.filter(rotina => rotina.responsavel !== 'Rotina');

      if (resultadoHistorico) {
        resultadoHistorico.forEach((historico, index) => {
          historico.index = index + 1;
        });
      }

      setHistoricos(resultadoHistorico);
    }
  };

  const getTiposClassificacaoProjetos = async () => {
    const result = await getAllCrfTipoClassificacaoProjeto();
    if (result && Array.isArray(result)) {
      setTiposClassificacaoProjetos(result);
    }
  }

  useEffect(() => {
    listarParametros();
    listarHistorico();
    getTiposClassificacaoProjetos();
  }, []);

  const listarHistorico = async () => {
    setHistoricos([]);
    getHistoricoData();
  };

  const listarParametros = async () => {
    setParametros([]);
    getParametrosData();
  };


  const handleUpdate = async (param: Parametro) => {
    const result = await updateParametro(param);
    if (result) {
      listarParametros();
      listarHistorico();
    }
  };

  const handleUpdateTipoClassificacaoProjeto = async (tipoClassificacaoProjeto: CrfTipoClassificacaoProjeto) => {
    const result = await updateCrfTipoClassificacaoProjeto(tipoClassificacaoProjeto);
    if(result){
      getTiposClassificacaoProjetos();
    }
  }


  return (
    <>
      <SimpleView>
        <GridView title="" noform>
          <Collapse bordered={false} defaultActiveKey={['2']} expandIcon={() => <Icon type="arrows-right_4" />}>
            <Panel key="2" header="PARÂMETROS SCE" style={{ border: 0 }}>
              <MasterDetailForm>
                <Widget title="">
                  <TabelaParametro param={parametros || []} handleUpdate={handleUpdate} />
                </Widget>
              </MasterDetailForm>
            </Panel>
          </Collapse>

          <Collapse defaultActiveKey={[]} bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
            <Panel key="3" header="Histórico de alterações" style={{ border: 0 }}>
              <MasterDetailForm>
                <Widget title="" >
                  <TabelaHistorico hist={historicos || []} paginacao={10} relatorioRotinaParamentro={false} />
                </Widget>
              </MasterDetailForm>
            </Panel>
          </Collapse>

          {/* <Collapse defaultActiveKey={['4']} bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
            <Panel key="4" header="Parâmetros de Integração SSIS" style={{ border: 0 }}>
              <MasterDetailForm>
                <Widget title="" >
                  <TabelaTipoClassificacaoProjeto data={tiposClassificacaoProjetos || []} paginacao={10} handleUpdate={handleUpdateTipoClassificacaoProjeto} />
                </Widget>
              </MasterDetailForm>
            </Panel>
          </Collapse> */}

        </GridView>
      </SimpleView>
    </>
  );
};

export default ConfiguracaoComponent;
